import React, { useRef } from 'react';
import { useEffect, useState } from "react";
import Select from 'react-select';
import "../../../../assets/css/master.css"
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { alphaNumericspace, isValidEmail, onlyAlphabets, onlyNumeric, generatePDF } from '../../../commonClass/CommonValidation';
import validator from 'validator';
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../../_actions/loader.actions";
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import CustomSelection from '../../../../customControl/CustomSelection';
import { GetMenuIdFromStorage } from '../../../commonClass/Menudect';
import { ExportExcel } from '../../../commonClass/ExportExcel';
import CustomTable from '../../../../customControl/CustomTable';

const AccesspointmasterRailway = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({});
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(true);
    const [activeId, setActiveId] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [disabled, setDisabled] = useState();
    const [clrshow, setsclshow] = useState(false);
    const [railwaydata, setRailwayData] = useState([]);
    const [useredit, setUserEdit] = useState(true);
    const [useradd, setUserAdd] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const [citydisable, setCityDisable] = useState(false);
    const user = useSelector(store => store.userstatus.tba);
    const [allCity, setallCity] = useState([]);
    const [citydata, setCityData] = useState([]);
    const [cityid, setCity] = useState(0);
    const [alllocation, setAllLocation] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [form, setForm] = useState({
        AccessPointRailwayId: 0,
        LocationId: 0,
        RailwayStationName: '',
        RailwayStationCode: '',
        Latitude: '',
        Longitude: '',
        EmailId: '',
        MobNoCode: '',
        MobNo: '',
        Address: '',
        Pincode: '',
        LandlineNoCode: '',
        LandlineNo: '',
        WebsiteURL: '',
        IsActive: false,
        UserId: 0
    });
    const onSubmitForm = e => {
        e.preventDefault();
        setFormErrors(validate(form));
        //handleSubmitData();
    };
    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            form.IsActive = e
            setActiveId(!activeId)
            setFormErrors('');
        }
        else {
            setModalShow(true);
        }
    }
    const handleConfirmation = (e) => {
        if (e === true) {
            form.IsActive = !activeId
            setActiveId(!activeId)
            setEditDisabled(true);
            setFormErrors('');
        }
        setModalShow(false);
    }
    //#region bind datatable
    const columns = [
        {
            name: 'Railway Station Name',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Railway) => Railway.RailwayStationName
        },
        {
            name: 'Station Code',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Railway) => Railway.RailwayStationCode
        },
        {
            name: 'Latitude/Longitude',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Railway) => (Railway.Latitude + '/' + Railway.Longitude)
        },
        {
            name: 'City',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Railway) => Railway.City
        },
        {
            name: 'State',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Railway) => Railway.StateName
        },

        {
            name: 'Active',
            sortable: true,
            float: "left",
            // selector: location => <td style={{ textAlign: "center", width: "5%" }}>
            //     {`${location.inActive ? 'InActive' : 'Active'}`}</td>
            selector: (Railway) => Railway.IsActive ? 'Active' : 'InActive'
        },
        {
            name: 'Created Date',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (Railway) => new Date(Railway.CreatedOn),
            format: (Railway) => formatDateRequire(Railway.CreatedOn),
        },
        {
            name: 'Edit',
            // float:"right",
            // selector: location => < td style={{ textAlign: "center", width: "5%", cursor:"pointer" }} onClick={() => handleEditMode(location.tagId)}> <i className="fa fa-edit"></i></td >
            selector: (Railway) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditMode(Railway.AccessPointRailwayId)}></i></button>
        },
        {
            name: 'View',
            // float:"right",
            // selector: location => <td style={{ textAlign: "center", width: "5%", cursor:"pointer" }} onClick={() => handleViewMode(location.tagId)}><i className="fa fa-eye"></i></td>
            selector: (Railway) => <i className="fa fa-eye" onClick={() => handleViewMode(Railway.AccessPointRailwayId)}></i>// onClick={() => handleViewMode(banner.bannerId)}
        }
    ];


    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }

    function PdfExport() {
        //print
        const columns = [
            "Railway Station Name",
            "Station Code",
            "Latitude",
            "Longitude",
            "City",
            "State",
            "Active",
            "Created Date"
        ];
        var rows = [];

        for (let i = 0; i < railwaydata?.length; i++) {
            var temp = [
                railwaydata[i].RailwayStationName,
                railwaydata[i].RailwayStationCode,
                railwaydata[i].Latitude,
                railwaydata[i].Longitude,
                railwaydata[i].City,
                railwaydata[i].StateName,
                `${railwaydata[i].IsActive ? 'Active' : 'InActive'}`,
                formatDate(railwaydata[i].CreatedOn)
            ];
            rows = [...rows, temp]
        }
        generatePDF(columns, rows, "RailwayStation", "Railway Station")
    };

    const ExportToExcel = () => {
        const displayname = [
            "Railway Station Name",
            "Station Code",
            "Latitude", "Longitude",
            "City",
            "State",
            "Active",
            "Created Date"
        ];
        const fields = ['RailwayStationName', 'RailwayStationCode', 'Latitude', 'Longitude', 'City', 'StateName', 'IsActive', 'CreatedOn'];
        ExportExcel(displayname, fields, railwaydata, 'Railway', 'Railway.xls')
    }

    function formatDateRequire(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }

    //#endregion

    //#region handling search
    const serachoption = [
        {
            label: 'Railway Station Name',
            value: '1'
        },
        {
            label: 'Station Code',
            value: '7'
        },
        {
            label: 'Latitude/Longitude',
            value: '2'
        },
        {
            label: 'City',
            value: '3'
        },
        {
            label: 'State',
            value: '4'
        },
        {
            label: 'Active',
            value: '5'
        },
        {
            label: 'All',
            value: '6'
        },

    ];

    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            form.UserId = token?.userMasterID
            // (Window.$name && Window.$userToken) {
            getRailwaylist();
            getcitylist();
            setitems();
        }
        else {
            ClearLocalStorage();
            // alert('Your Session Expired. Please Login Again!');
            // navigate('/');
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }

    }, []);

    useEffect(() => {
        // let pagelink = user?.find(x => {
        //     if (x.PageLink === window.location.pathname)
        //         return x.MenuId
        // });
        if (window.location.pathname !== '/dashboard') {
            let pagelink = user?.find(x => {
                if (x.PageLink === window.location.pathname)
                    return x.MenuId
            });
            let mid = user?.find(x => x.MenuId === pagelink.MenuId);
            if (mid?.URightView === false && mid?.URightView !== undefined) {
                navigate('/dashboard');
            }
            user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
                setUserAdd(obj.URightAdd);
                setUserEdit(obj.URightEdit);
                setUserExport(obj.URightExport);

            });
        }
    }, [user])
    //#endregion

    const getRailwaylist = async () => {
        await getAllData('/master/v1/getallaccesspointrailway').then((railwaydata) => {
            setRailwayData(railwaydata.data);
        });
    }
    const LocationId = useRef(null);
    const getcitylist = async () => {
        await getAllData('/master/v1/getallcity').then((railwaydata) => {
            setallCity(railwaydata.data);
            setCityData(railwaydata.data?.filter(IsAct => IsAct.IsActive === true));
            dispatch(loaderActions.end());
        });
    }
    const cityList = citydata?.map(value => ({
        label: value.City,
        value: value.LocationId
    }));
    const getalllocationbyCity = async (locationid) => {
        const locid = { LocationId: locationid }
        await postUsersData('/master/v1/getlocationbyid', locid).then((AllLocationData) => {
            setAllLocation(AllLocationData.data);
        });
    }
    const continent = alllocation?.map(value => ({
        label: value.continentName,
        value: 1
    })
    );

    const country = alllocation?.map(value => ({
        label: value.countryName,
        value: 1
    })
    );

    const region = alllocation?.map(value => ({
        label: value.regionName,
        value: 1
    })
    );

    const state = alllocation?.map(value => ({
        label: value.stateName,
        value: 1
    })
    );
    const handleEditMode = (id) => {
        setDisabled(false);
        setButtonAddEditText("Update");
        setSerachDisable(true);
        RetriveData(id);
        setEditDisabled(false);
    }
    const handleViewMode = (id) => {
        setDisabled(true);
        setEditDisabled(false);
        setSerachDisable(true);
        RetriveData(id);
    }
    function RetriveData(id) {
        setFormErrors('');
        railwaydata?.map(obj => {

            if (obj.AccessPointRailwayId === id) {
                form.AccessPointRailwayId = obj.AccessPointRailwayId
                form.LocationId = obj.LocationId
                form.RailwayStationName = obj.RailwayStationName
                form.RailwayStationCode = obj.RailwayStationCode
                form.Latitude = obj.Latitude
                form.Longitude = obj.Longitude
                form.EmailId = obj.EmailId
                form.MobNoCode = obj.MobNoCode
                form.MobNo = obj.MobNo
                form.Address = obj.Address
                form.Pincode = obj.Pincode
                form.LandlineNoCode = obj.LandlineNoCode
                form.LandlineNo = obj.LandlineNo
                form.WebsiteURL = obj.WebsiteURL
                form.IsActive = obj.IsActive
                // Check In-Active Data and add in Dropdown...
                let allcitylist = allCity?.filter(IsAct => IsAct.IsActive === true);
                setCityData(allCity?.filter(IsAct => IsAct.IsActive === true));
                setCityDisable(false);
                if (!allcitylist?.find(IsCity => IsCity.LocationId === obj.LocationId)) {
                    setCityDisable(true)
                    setCityData((prvCityData) => prvCityData?.length > 0 ? [...prvCityData, allCity?.find(isCity => isCity.LocationId === obj.LocationId)] : [])
                    // setCityData((prvCityData) => [...prvCityData, allCity?.find(isCity => isCity.locationId === obj.locationId)])

                }
                setCity(obj.LocationId);
                getalllocationbyCity(obj.LocationId);


                setActiveId(obj.IsActive);
            }
        });

    }
    const handlecity = (e) => {
        form.LocationId = e.value
        setCity(e.value);
        getalllocationbyCity(e.value);
        setFormErrors('');
        setEditDisabled(true);
    }
    const validate = (values) => {
        setIsSubmit(true);
        const error = {}
        if (values.LocationId === 0) {
            error.LocationId = "Kindly select the City name";
            setIsSubmit(false);
        }
        if (!values.RailwayStationName || values.RailwayStationName?.trim()?.length === 0) {
            error.RailwayStationName = "Kindly Enter The Railway Station Name";
            setIsSubmit(false);
        }
        if (values.EmailId?.trim()?.length > 0 && !isValidEmail(values.EmailId)) {
            error.EmailId = "Email id should in a format abc@xyz.com";
            setIsSubmit(false);
        }
        if (values.WebsiteURL?.length > 0 && !validator.isURL(values.WebsiteURL)) {
            if (!validator.isURL(values.WebsiteURL)) {
                error.WebsiteURL = "Only website links can be added here.";
                setIsSubmit(false);
            }
        }
        return error;
    }

    const handleSubmitData = async () => {
        let statusoftoken = await verifytoken();
        if (buttonaddeditText === 'Add') {
            if (statusoftoken) {
                const Railwaydata = await postUsersData('/master/v1/insertaccesspointrailway', form)
                const status = Railwaydata.status;
                if (!Railwaydata.status && !Railwaydata.data) {
                    dispatch({ type: 'ALERTING', message: Railwaydata.message });
                    setDisabled(false);
                    setEditDisabled(true);
                    setIsSubmit(false);
                    return;
                }
                if (status) {
                    dispatch({ type: 'ALERTING', message: Railwaydata.message });
                    getRailwaylist();
                    setitems();
                    clear();
                    setDisabled(false);
                    setEditDisabled(true);
                }
                else {
                    dispatch({ type: 'ALERTING', message: Railwaydata.message })
                    setDisabled(false);
                    setEditDisabled(true);
                    return;
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        else {
            if (statusoftoken) {
                const Railwaydata = await patchUsersData('/master/v1/updateaccesspointrailway', form)
                const status = Railwaydata.status;
                if (!Railwaydata.status && !Railwaydata.data) {
                    dispatch({ type: 'ALERTING', message: Railwaydata.message });
                    setDisabled(false);
                    setEditDisabled(true);
                    setIsSubmit(false);
                    return;
                }
                if (status) {
                    dispatch({ type: 'ALERTING', message: Railwaydata.message });
                    getRailwaylist();
                    setitems();
                    clear();
                }
                else {
                    dispatch({ type: 'ALERTING', message: Railwaydata.message })
                    setDisabled(false);
                    setEditDisabled(true);
                    return;
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }

    }
    useEffect(() => {
        if (Object.keys(formErrors)?.length === 0 && isSubmit) {
            setDisabled(true);
            setEditDisabled(false);
            handleSubmitData();
        }
        if (Object.keys(formErrors).length > 0) {

            let id = Object.keys(formErrors)[0];
            if (id === "LocationId") {
                eval(id).current.focus();
            }
            else {
                let doc = document.getElementById(id);
                if (doc !== null)
                    doc.focus();
            }
        }

    }, [formErrors]);

    const onChange = (e) => {
        var result;
        if ([e.target.name][0] === 'MobNo') {
            result = onlyNumeric(e.target.value)
        }
        else if ([e.target.name][0] === 'RailwayStationName') {
            result = alphaNumericspace(e.target.value)
        }
        else if ([e.target.name][0] === 'RailwayStationCode') {
            result = onlyAlphabets(e.target.value)
        }
        else {
            result = e.target.value;
        }
        setForm({ ...form, [e.target.name]: result });
        setEditDisabled(true);
        setFormErrors('');
    }
    const handleClearClick = () => {
        clear();
    }
    function clear() {
        setButtonAddEditText('Add');
        setIsSubmit(false);
        setDisabled(false);
        setFormErrors('');
        setForm({
            ...form, ['RailwayStationName']: '', ['RailwayStationCode']: '', ['LocationId']: 0, ['Latitude']: '', ['Longitude']: '', ['EmailId']: '',
            ['MobNoCode']: '', ['IsActive']: false, ['AccessPointRailwayId']: 0, ['MobNo']: '', ['Address']: '',
            ['Pincode']: '', ['LandlineNoCode']: '', ['LandlineNo']: '', ['WebsiteURL']: ''
        });
        setCity(0);
        setAllLocation([]);
        setActiveId(false);
        getcitylist();
        getRailwaylist();
        setCityDisable(false);
        setCityData([]);
        setEditDisabled(true);
        setSerachDisable(false);
        setSerachBy('6');
        setSearchValue('');
    }
    const [searchvalue, setSearchValue] = useState();
    const [searchby, setSerachBy] = useState('6');
    const [serchdisable, setSerachDisable] = useState(false);
    const [filteritems, setFilterItems] = useState([]);

    const setitems = async () => {
        await getAllData("/master/v1/getallaccesspointrailway").then((railwaydata) => {
            setFilterItems(railwaydata.data);
        });
    }

    const handleSearchBy = (e) => {
        setSerachBy(e.value);
    }
    const handleChangeSearchValue = (e) => {
        setSearchValue(e.target.value)
        setsclshow(true)
        if (e.target.value === '') {
            getRailwaylist();
            setsclshow(false);
        }
    }

    const onKeyDownHandler = (e) => {
        if (e.keyCode === 13) {
            handleSearch();
        }
    };

    const handleSearch = () => {
        if (typeof searchvalue === 'string' && searchvalue?.trim()?.length !== 0 && searchby > 0) {
            setitems();
            var filteritem = filteritems;
            var filterdata;
            if (searchby === '1') {
                filterdata = filteritem?.filter(issec => issec.RailwayStationName.toLowerCase().includes(searchvalue.toLowerCase()));
            }
            else if (searchby === '2') {
                filterdata = filteritem?.filter(issec => issec.Latitude.toLowerCase().includes(searchvalue.toLowerCase()) || issec.Longitude.toLowerCase().includes(searchvalue.toLowerCase()));
            }
            else if (searchby === '3') {
                filterdata = filteritem?.filter(issec => issec.City.toLowerCase().includes(searchvalue.toLowerCase()));
            }
            else if (searchby === '4') {
                filterdata = filteritem?.filter(issec => issec.StateName.toLowerCase().includes(searchvalue.toLowerCase()));
            }
            else if (searchby === '7') {
                filterdata = filteritem?.filter(issec => issec.RailwayStationCode.toLowerCase().includes(searchvalue.toLowerCase()));
            }
            else if (searchby === '5') {
                if (searchvalue.toLowerCase() === 'active'.toLowerCase()) {
                    filterdata = filteritem?.filter(issec => issec.IsActive === true);
                }
                else if (searchvalue.toLowerCase() === 'inactive'.toLowerCase()) {
                    filterdata = filteritem?.filter(issec => issec.IsActive === false);
                }
                else if ('active'.toLowerCase().includes(searchvalue.toLowerCase())) {
                    filterdata = filteritem?.filter(issec => issec.IsActive === true || issec.IsActive === false);
                }
                else if ('inactive'.toLowerCase().includes(searchvalue.toLowerCase())) {
                    filterdata = filteritem?.filter(issec => issec.IsActive === false);
                }
                else {
                    filterdata = filteritem?.filter(issec => formatDateRequire(issec.CreatedOn).toLowerCase().includes("%#$&%^"));
                }
            }
            else if (searchby === '6') {
                if (searchvalue.toLowerCase() === 'active'.toLowerCase()) {
                    filterdata = filteritem?.filter(issec => issec.RailwayStationName.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.Latitude.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.Longitude.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.City.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.StateName.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.RailwayStationCode.toLowerCase().includes(searchvalue.toLowerCase())
                        || formatDateRequire(issec.CreatedOn)?.toLowerCase().includes(searchvalue?.toLowerCase())
                        || issec.IsActive === true);
                }
                else if (searchvalue.toLowerCase() === 'inactive'.toLowerCase()) {
                    filterdata = filteritem?.filter(issec => issec.RailwayStationName.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.Latitude.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.Longitude.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.City.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.StateName.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.RailwayStationCode.toLowerCase().includes(searchvalue.toLowerCase())
                        || formatDateRequire(issec.CreatedOn)?.toLowerCase().includes(searchvalue?.toLowerCase())
                        || issec.IsActive === false);
                }
                else if ('active'.toLowerCase().includes(searchvalue.toLowerCase())) {
                    filterdata = filteritem?.filter(issec => issec.RailwayStationName.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.Latitude.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.Longitude.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.City.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.StateName.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.RailwayStationCode.toLowerCase().includes(searchvalue.toLowerCase())
                        || formatDateRequire(issec.CreatedOn)?.toLowerCase().includes(searchvalue?.toLowerCase())
                        || issec.IsActive === true
                        || issec.IsActive === false);
                }
                else if ('inactive'.toLowerCase().includes(searchvalue.toLowerCase())) {
                    filterdata = filteritem?.filter(issec => issec.RailwayStationName.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.Latitude.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.Longitude.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.City.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.StateName.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.RailwayStationCode.toLowerCase().includes(searchvalue.toLowerCase())
                        || formatDateRequire(issec.CreatedOn)?.toLowerCase().includes(searchvalue?.toLowerCase())
                        || issec.IsActive === false);
                }
                else {
                    filterdata = filteritem?.filter(issec => issec.RailwayStationName.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.Latitude.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.Longitude.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.City.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.StateName.toLowerCase().includes(searchvalue.toLowerCase())
                        || issec.RailwayStationCode.toLowerCase().includes(searchvalue.toLowerCase())
                        || formatDateRequire(issec.CreatedOn)?.toLowerCase().includes(searchvalue?.toLowerCase())
                        || 'active'.toLowerCase().includes(searchvalue.toLowerCase()) || 'inactive'.toLowerCase().includes(searchvalue.toLowerCase()));
                }
            }
            setRailwayData(filterdata)
        }
    }

    const clearsearch = () => {
        setSearchValue("");
        setsclshow(false);
        getRailwaylist();
    }
    //#endregion


    return (
        <>
            <div class="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div class="mb-3 row mx-1">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="row">
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div class="col-lg-12 col-md-12">
                                        <label for="inputPassword6" class="col-form-label required">Continent</label>
                                    </div>
                                    <div class="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={continent?.find(({ value }) => value === 1)}
                                            options={continent}
                                        />
                                    </div>

                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div class="col-lg-12 col-md-12">
                                        <label for="inputPassword6" class="col-form-label required">Country</label>
                                    </div>
                                    <div class="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={country?.find(({ value }) => value === 1)}
                                            options={country}
                                        />
                                    </div>

                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div class="col-lg-12 col-md-12">
                                        <label for="inputPassword6" class="col-form-label required">Region</label>
                                    </div>
                                    <div class="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={region?.find(({ value }) => value === 1)}
                                            options={region}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div class="col-lg-12 col-md-12">
                                        <label for="inputPassword6" class="col-form-label required">State</label>
                                    </div>
                                    <div class="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={state?.find(({ value }) => value === 1)}
                                            options={state}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div class="col-lg-12 col-md-12">
                                        <label for="inputPassword6" class="col-form-label required">City</label>
                                    </div>
                                    <div class="col-lg-12 mb-1 col-md-12">
                                        <CustomSelection
                                            datalist={cityList}
                                            selId='LocationId'
                                            selRef={LocationId}
                                            fieldid={cityid}
                                            SelectionChange={handlecity}
                                            isdisable={disabled}
                                            isactivedisable={citydisable}
                                            issearchable={true}
                                        />
                                        {formErrors.LocationId && <p className='text-danger text-start'>{formErrors.LocationId}</p>}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-1 mt-4 col-lg-11 mx-lg-5">
                        <div className='row'>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label required">Railway Station Name</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='RailwayStationName'
                                            name="RailwayStationName"
                                            value={form.RailwayStationName}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Railway Station Name'
                                            maxLength={200}
                                        />
                                        {formErrors.RailwayStationName && <p className='text-danger text-start'>{formErrors.RailwayStationName}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Station Code</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='RailwayStationCode'
                                            name="RailwayStationCode"
                                            value={form.RailwayStationCode}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Station Code'
                                            maxLength={50}
                                        />
                                        {/* {formErrors.RailwayStationName && <p className='text-danger text-start'>{formErrors.RailwayStationName}</p>} */}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Latitude</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='Latitude'
                                            name="Latitude"
                                            value={form.Latitude}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Latitude'
                                            maxLength={20}
                                        />
                                        {/* {formErrors.SupplierName && <p className='text-danger text-start'>{formErrors.SupplierName}</p>} */}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Longitude</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='Longitude'
                                            name="Longitude"
                                            value={form.Longitude}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Longitude'
                                            maxLength={20}
                                        />
                                        {/* {formErrors.SupplierName && <p className='text-danger text-start'>{formErrors.SupplierName}</p>} */}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Email Id</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='EmailId'
                                            name="EmailId"
                                            value={form.EmailId}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Email Id'
                                            maxLength={70}
                                        />
                                        {formErrors.EmailId && <p className='text-danger text-start'>{formErrors.EmailId}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Landline Number</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <div className='input-group'>
                                            <input class="form-control"
                                                type="text"
                                                id='LandlineNoCode'
                                                name="LandlineNoCode"
                                                value={form.LandlineNoCode}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder='Code'
                                                maxLength={6}
                                            />
                                            <input class="form-control"
                                                type="text"
                                                id='LandlineNo'
                                                name="LandlineNo"
                                                value={form.LandlineNo}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder='Landline Number'
                                                maxLength={15}
                                            />
                                        </div>
                                        {/* {formErrors.SupplierName && <p className='text-danger text-start'>{formErrors.SupplierName}</p>} */}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Mobile Number</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <div className='input-group'>
                                            <input class="form-control"
                                                type="text"
                                                id='MobNoCode'
                                                name="MobNoCode"
                                                value={form.MobNoCode}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder='Code'
                                                maxLength={6}
                                            />
                                            <input class="form-control"
                                                type="text"
                                                id='MobNo'
                                                name="MobNo"
                                                value={form.MobNo}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder='Mobile Number'
                                                maxLength={15}
                                            />
                                        </div>
                                        {/* {formErrors.SupplierName && <p className='text-danger text-start'>{formErrors.SupplierName}</p>} */}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Website URL</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input class="form-control"
                                            type="text"
                                            id='WebsiteURL'
                                            name="WebsiteURL"
                                            value={form.WebsiteURL}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Website URL'
                                        />
                                        {formErrors.WebsiteURL && <p className='text-danger text-start'>{formErrors.WebsiteURL}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div class="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Pincode</label>
                                    </div>
                                    <div class=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input type="text"
                                            id="Pincode"
                                            class="form-control"
                                            name="Pincode"
                                            value={form.Pincode}
                                            disabled={disabled ? true : false}
                                            onChange={onChange}
                                            maxLength={15}
                                            placeholder='Pincode' />
                                        {/* {formErrors.Website && <p className='text-danger text-start'>{formErrors.Website}</p>} */}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-12 col-sm-12 '>
                                <div className='row'>
                                    <div class="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Address</label>
                                    </div>
                                    <div class=" col-lg-9 col-md-12 col-sm-12 mb-lg-1 mb-md-2">
                                        <textarea class="form-control"
                                            id="textAreaExample3"
                                            rows="2"
                                            name="Address"
                                            value={form.Address}
                                            disabled={disabled ? true : false}
                                            onChange={onChange}
                                            placeholder='Address'
                                            maxLength={300}
                                        >

                                        </textarea>
                                        {/* {formErrors.AboutSupplier && <p className='text-danger text-start'>{formErrors.AboutSupplier}</p>} */}
                                    </div>

                                </div>
                            </div>
                            <div class="col-lg-12 col-sm-12">
                                <div class='row'>
                                    <div class="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                        <label for="inputPassword6" class="col-form-label">Active</label>
                                    </div>
                                    <div class=" col-lg-9 col-md-12 col-sm-12 mb-lg-1 mb-md-2">
                                        <Switch
                                            onChange={handleisActive}
                                            checked={activeId}
                                            className="react-switch"
                                            disabled={disabled ? true : false}
                                        />
                                    </div>
                                    <ConfirmationModal
                                        show={modalShow}
                                        onHide={() => setModalShow(false)}
                                        noconfirm={() => handleConfirmation(false)}
                                        yesconfirm={() => handleConfirmation(true)}
                                    />

                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3 d-flex justify-content-center">
                        {useradd === false && buttonaddeditText === "Add" ?
                            <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={onSubmitForm} disabled={!useradd}>{buttonaddeditText}</button> :
                            <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={onSubmitForm} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                        <button type="button" class="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
                    </div>
                    <div class="row mt-3">
                        <div className='d-lg-flex d-md-flex d-sm-block justify-content-end'>
                            <div class="p-2 col-lg-2 col-md-4 col-sm-12">
                                <Select
                                    className="dropdown select_dropdown"
                                    options={serachoption}
                                    value={serachoption?.filter(function (serachoption) {
                                        return serachoption.value === searchby;
                                    })}// set list of the dataalue 
                                    onChange={handleSearchBy} // assign onChange function
                                    isDisabled={serchdisable ? true : false}
                                    isSearchable={false}

                                />
                            </div>
                            <div class="p-2 col-lg-2 col-md-4 col-sm-12">
                                <div className='clrbutton'>
                                    <input type="text" onKeyDown={onKeyDownHandler} id="btnSearchText" class="form-control" placeholder='Enter keyword' name="SearchValue" onChange={handleChangeSearchValue} value={searchvalue || ''} disabled={serchdisable ? true : false} />
                                    <button className={`${clrshow === true ? "d-block" : "d-none"}`} disabled={serchdisable ? true : false} onClick={clearsearch} type="reset">&times;</button>
                                </div>
                            </div>
                            <div class="p-2 text-center">
                                <button type="button" class="btn btn-primary mx-1" id="btnSearch" disabled={serchdisable ? true : false} onClick={handleSearch} >Search</button>
                            </div>
                        </div>

                    </div>

                    <CustomTable
                        columns={columns}
                        data={railwaydata}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    )
}

export default AccesspointmasterRailway